import React from 'react'

import { Wrapper } from './GridItem.styles'

const GridItem = ({
    opacity,
    transition,
    refID,
    borderRadius,
    width,
    height,
    position,
    top,
    right,
    bottom,
    boxShadow,
    left,
    margin,
    children,
    whiteSpace,
    gridArea,
    gridCol,
    gridRow,
    display,
    gridTempRows,
    gridTempCols,
    gridTemplate,
    gridAutoRows,
    gridAutoCols,
    gridAutoFlow,
    gridRowGap,
    gridColGap,
    gap,
    alignText,
    flexWrap,
    justifyContent,
    flexDirection,
    justifyItems,
    justifySelf,
    alignSelf,
    alignItems,
    alignContent,
    fontSize,
    letterSpacing,
    overflow,
    color,
    background,
    textTransform,
    zIndex,
    onClick,
    cursor,
    padding,
    fontWeight,
    borderBottom, ...props }) => {
    const isObject = (variable) => {
        return typeof (variable) === 'object' && !Array.isArray(variable) && variable !== null
    }
    return (
        <Wrapper
            ref={refID ? refID : undefined}
            position={position}
            zIndex={zIndex}
            top={top}
            right={right}
            bottom={bottom}
            background={background}
            textTransform={textTransform}
            boxShadow={boxShadow}
            cursor={cursor}
            transition={transition}
            opacity={opacity}
            display={display}
            onClick={typeof (onClick) === 'function' ? onClick : undefined}
            margin={margin}
            padding={padding}
            overflow={overflow}
            height={height}
            left={left}
            width={width}
            flexDirection={flexDirection}
            flexWrap={flexWrap}
            justifySelf={justifySelf}
            alignSelf={alignSelf}
            gridTempRows={isObject(gridTemplate) ? gridTemplate.rows : gridTempRows}
            gridTempCols={isObject(gridTemplate) ? gridTemplate.cols : gridTempCols}
            gridAutoRows={gridAutoRows}
            gridAutoCols={gridAutoCols}
            gridAutoFlow={gridAutoFlow}
            gridColGap={gridColGap || gap}
            gridRowGap={gridRowGap || gap}
            whiteSpace={whiteSpace}
            gridArea={gridArea}
            gridCol={gridCol}
            gridRow={gridRow}
            letterSpacing={letterSpacing}
            alignText={alignText}
            justifyContent={justifyContent}
            justifyItems={justifyItems}
            alignContent={alignContent}
            alignItems={alignItems}
            color={color}
            fontSize={fontSize}
            fontWeight={fontWeight}
            borderBottom={borderBottom}
            borderRadius={borderRadius}
            {...props}
        >{children}</Wrapper>
    )
}

export default GridItem